import { Toolbar } from "@mui/x-data-grid-pro";
import DownloadIcon from "@mui/icons-material/Download";
import { Grid, styled } from "@mui-wrapper";
import { FilterToolbar } from "@components/common/data-grid/toolbar/filter-toolbar";
import { DataGridToolbarProps } from "@components/common/data-grid/adm-data-grid-types";
import { QuickSearchToolbar } from "@components/common/data-grid/toolbar/quick-search-toolbar";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { GeneralTableEvents } from "@utils/track-event/track-event-list";
import { IconButton, Tooltip } from "@flat-ui";

const DataGridToolbarRoot = styled(Toolbar)(({ theme }) => ({
  // MUI X sizes the toolbar with `flex: 0 1 1px`, so it can't grow when the buttons wrap onto a second line
  flex: "0 0 auto",
  // MUI X draws a line under its toolbar, which would sit right above the column headers
  borderBottom: "none",
  justifyContent: "space-between",
  alignItems: "flex-start",
  flexWrap: "wrap",
  gap: theme.spacing(1),
}));

/** Custom toolbar with search and export buttons */
export function DataGridToolbar({
  onExport,
  additionalToolbarButtons,
  leadingToolbarButtons,
  setActiveFilters,
  activeFilters,
  filterGroups = [],
  tableType,
}: DataGridToolbarProps): React.JSX.Element {
  const { trackEvent } = useTrackEvent();
  return (
    <DataGridToolbarRoot>
      {/* The search leads, as in the Dashboard, followed by the filters */}
      <Grid container sx={{ alignItems: "flex-start", gap: 1 }}>
        <QuickSearchToolbar />
        <FilterToolbar
          filterGroups={filterGroups}
          activeFilters={activeFilters}
          setActiveFilters={setActiveFilters}
          tableType={tableType}
        />
      </Grid>

      <Grid container sx={{ alignItems: "flex-start", gap: 1 }}>
        {leadingToolbarButtons}
        {onExport && (
          <Tooltip title="Export as CSV">
            <IconButton
              aria-label="Export as CSV"
              onClick={() => {
                trackEvent({
                  name: GeneralTableEvents.exportAsCsv,
                  props: {
                    location: tableType,
                  },
                });
                onExport();
              }}
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        )}
        {additionalToolbarButtons}
      </Grid>
    </DataGridToolbarRoot>
  );
}
